import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { UNIT_SYSTEM_OPTIONS, UnitSystemOption } from '../data.types';

interface Props {
  fullscreen: boolean,
  videoEnabled: boolean,
  unitSystem: UnitSystemOption
}
interface Emits {
  (event: 'update:fullscreen', value: boolean): void
  (event: 'update:videoEnabled', value: boolean): void,
  (event: 'update:unitSystem', value: UnitSystemOption): void,
  (event: 'refresh'): void
}

export default /*#__PURE__*/_defineComponent({
  __name: 'menu',
  props: {
    fullscreen: { type: Boolean },
    videoEnabled: { type: Boolean },
    unitSystem: null
  },
  emits: ["update:fullscreen", "update:videoEnabled", "update:unitSystem", "refresh"],
  setup(__props: any, { emit: $emit }: { emit: ({
  (event: 'update:fullscreen', value: boolean): void
  (event: 'update:videoEnabled', value: boolean): void,
  (event: 'update:unitSystem', value: UnitSystemOption): void,
  (event: 'refresh'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  fullscreen: boolean,
  videoEnabled: boolean,
  unitSystem: UnitSystemOption
};





let fullscreenInput = computed({
  get() {
    return props.fullscreen
  },
  set(value: boolean) {
    $emit("update:fullscreen", value)
  }
})

let videoEnabledInput = computed({
  get() {
    return props.videoEnabled
  },
  set(value: boolean) {
    $emit("update:videoEnabled", value)
  }
})

let unitSystemInput = computed({
  get() {
    return props.unitSystem
  },
  set(value: UnitSystemOption) {
    $emit("update:unitSystem", value)
  }
})

return { __sfc: true,props, $emit, fullscreenInput, videoEnabledInput, unitSystemInput, UNIT_SYSTEM_OPTIONS }
}

})